import React from 'react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/solid'
import { useConfig } from 'msp-integrations'
import * as Flags from '../flags'
import { CountrySelected } from '../PhoneField.styles'
import type { CountryType } from '../PhoneField.helpers'

export const PhoneFieldCountrySelect = ({
  isDropdownOpen,
  country
}: {
  isDropdownOpen: boolean
  country: CountryType
}) => {
  const {
    theme: {
      font: { regular: font }
    }
  } = useConfig()
  const CountryFlag = Flags[country.iso]

  return (
    <div className={`${font} ${CountrySelected}`}>
      <CountryFlag />
      <p className='w-9 text-center'>{`+${country.prefix}`}</p>
      {isDropdownOpen ? (
        <ChevronUpIcon className='h-5 w-5' fill='black' stroke='white' />
      ) : (
        <ChevronDownIcon className='h-5 w-5' fill='black' stroke='white' />
      )}
    </div>
  )
}
